module.exports = __webpack_public_path__ + "img/organizations.76cdbb90.png";